/**
 * This specs defines messages
 */

const Messages = {
  //Network
  Network_SetStatus: 'Network_SetStatus',

  //RpiManager
  Rpi_DeviceInfo: 'Rpi_DeviceInfo',
  Rpi_PowerOff: 'Rpi_PowerOff',
  Rpi_Reboot: 'Rpi_Reboot',

  //WifiManager
  Wifi_GetAccessPoints: 'Wifi_GetAccessPoints',
  Wifi_GetConnectionProfiles: 'Wifi_GetConnectionProfiles',
  Wifi_GetDevices: 'Wifi_GetDevices',
  Wifi_ConnectProfile: 'Wifi_ConnectProfile',
  Wifi_RemoveProfile: 'Wifi_RemoveProfile',
  Wifi_ConnectionStatus: 'Wifi_ConnectionStatus',

  //Gps
  Gps_LastKnownLocation: 'Gps_LastKnownLocation',
  Gps_CurrentLocation: 'Gps_CurrentLocation',

  //VideoManger
  Video_Download: 'Video_Download',
  Video_DownloadStatus: 'Video_DownloadStatus',
  Video_DownloadCancel: 'Video_DownloadCancel',
  Video_Delete: 'Video_Delete',
  Video_DeleteAll: 'Video_DeleteAll',
  Video_PreviewOpen: 'Video_PreviewOpen',
  Video_PreviewClose: 'Video_PreviewClose',
  Video_PlayOpen: 'Video_PlayOpen',
  Video_PlayClose: 'Video_PlayClose',

  //VideoPlayer
  VideoPlayer_Start: 'VideoPlayer_Start',
  VideoPlayer_Status: 'VideoPlayer_Status',
  VideoPlayer_StatusRequest: 'VideoPlayer_StatusRequest',
  VideoPlayer_Pause: 'VideoPlayer_Pause',
  VideoPlayer_Resume: 'VideoPlayer_Resume',
  VideoPlayer_Stop: 'VideoPlayer_Stop',
  VideoPlayer_ChangeSubtitle: 'VideoPlayer_ChangeSubtitle',

  //Rfid
  Rfid_ReadStart: 'Rfid_ReadStart',
  Rfid_Tag: 'Rfid_Tag',
  Rfid_ReadStop: 'Rfid_ReadStop',

  //Display
  Display_GetDisplays: 'Display_GetDisplays',
  Display_SetResolution: 'Display_SetResolution',
}

export default Messages